var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "employee-item" }, [
    _c(
      "div",
      { staticClass: "employee-item__inner" },
      [
        _vm.employee.ImageHtml.Src || _vm.employee.ImageHtml.HasCrop
          ? _c("ResponsiveImage", {
              attrs: {
                imageModel: _vm.employee.ImageHtml,
                wrapClass: "employee-item__image"
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "employee-item__info-wrap" }, [
          _c("div", { staticClass: "employee-item__info" }, [
            _c("div", { staticClass: "employee-item__row" }, [
              _c("h3", { staticClass: "employee-item__name" }, [
                _vm._v(_vm._s(_vm.employeeItem.Name))
              ]),
              _vm._v(" "),
              _vm.employeeItem.HasTitle
                ? _c("p", { staticClass: "employee-item__title" }, [
                    _c("span", { staticClass: "employee-item__title-name" }, [
                      _vm._v(_vm._s(_vm.employeeItem.Title))
                    ]),
                    _vm._v(" "),
                    _vm.employeeItem.HasSegments
                      ? _c(
                          "span",
                          {
                            staticClass: "employee-item__title-segment",
                            style: { color: _vm.employeeItem.Segments[0].Color }
                          },
                          [_vm._v(_vm._s(_vm.employeeItem.Segments[0].Label))]
                        )
                      : _vm._e()
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _vm.employeeItem.HasPhone ||
            _vm.employeeItem.HasMobile ||
            _vm.employeeItem.HasEmail
              ? _c("div", { staticClass: "employee-item__row" }, [
                  _vm.employeeItem.HasPhone
                    ? _c("p", { staticClass: "employee-item__text" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.dictionaries.EmployeePhone) +
                            " "
                        ),
                        _c(
                          "a",
                          {
                            staticClass: "employee-item__link",
                            attrs: { href: "tel:" + _vm.employeeItem.Phone }
                          },
                          [_vm._v(_vm._s(_vm.employeeItem.Phone))]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.employeeItem.HasMobile
                    ? _c("p", { staticClass: "employee-item__text" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.dictionaries.EmployeeMobile) +
                            " "
                        ),
                        _c(
                          "a",
                          {
                            staticClass: "employee-item__link",
                            attrs: { href: "tel:" + _vm.employeeItem.Mobile }
                          },
                          [_vm._v(_vm._s(_vm.employeeItem.Mobile))]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.employeeItem.HasEmail
                    ? _c("p", { staticClass: "employee-item__text" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.dictionaries.EmployeeEmail) +
                            " "
                        ),
                        _c(
                          "a",
                          {
                            staticClass: "employee-item__link",
                            attrs: { href: "mailto:" + _vm.employeeItem.Email }
                          },
                          [_vm._v(_vm._s(_vm.employeeItem.Email))]
                        )
                      ])
                    : _vm._e()
                ])
              : _vm._e()
          ])
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-955155b2", { render: render, staticRenderFns: staticRenderFns })
  }
}